module.exports = __webpack_public_path__ + "static/media/mohammadmohammad.131c63c4.png";